import { FlexColumn, ImgBox } from "@/styles/layout/boxes";
import {Button, styled, Typography} from "@mui/material";

export const NoAvatarBox = styled(ImgBox)`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background: unset;
  border: solid 1px #ffffff;
  padding: 0.7rem;
`

export const UserInfoBox = styled(FlexColumn)`
  width: 80%;
  max-width: 10rem;
  margin-top: 5.5rem;
`

export const UserInfoWalletText = styled(Typography)`
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 90%;
  white-space: nowrap;
  font-size: 1.2rem;
  letter-spacing: 0.38px;
  margin-top: -0.7rem;
  opacity: 0.8;
`

UserInfoWalletText.defaultProps = {
    variant: 'body2',
}

export const UserInfoLoginButton = styled(Button)(({theme}) => ({
    width: '100%',
    backgroundColor: '#ffffff',
    '& p': {
        color: theme.palette.secondary.light,
    },
    borderRadius: '13px',
    marginTop: '2rem',
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: '#ffffff',
        boxShadow: 'none',
    }
}))
